<template>
  <label :class="$style.wrapper">
    <DolphinRadioButton
      :class="$style.wrapper__radiobutton"
      v-model="localGroupValue"
      :name="name"
      :value="value"
      :disabled="disabled"
    />
    <span
      :class="[$style.wrapper__text, { [$style['text--disabled']]: disabled }]"
      ><slot
    /></span>
  </label>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'
import type { OptionValueType } from '@/types/app'

const props = withDefaults(
  defineProps<{
    name: string
    modelValue?: OptionValueType
    value?: OptionValueType
    disabled?: boolean
  }>(),
  {
    modelValue: null,
    value: null,
    disabled: false,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: OptionValueType): void
}>()

const localGroupValue = computed({
  get: () => props.modelValue,
  set: (newValue: typeof props.modelValue) =>
    emit('update:modelValue', newValue),
})
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;

  &__text {
    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}

.text {
  &--disabled {
    color: $color-text-and-object-low-emphasis;
  }
}
</style>
